var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{attrs:{"id":"header"}},[_vm._v(_vm._s(_vm.tit))])
}
var staticRenderFns = []

export { render, staticRenderFns }